import ptTranslations from '@/locales/pt.json';
import enTranslations from '@/locales/en.json';
import esTranslations from '@/locales/es.json';

export type MenuLocale = 'pt' | 'es' | 'en';

const menuTranslations: Record<MenuLocale, Record<string, string>> = {
  pt: ptTranslations.menu,
  en: enTranslations.menu,
  es: esTranslations.menu,
};

export const getMenuLabels = (locale: MenuLocale): Record<string, string> => {
  return menuTranslations[locale] ?? menuTranslations.pt;
};